import { render, staticRenderFns } from "./accessGuideMenu.vue?vue&type=template&id=4db6bf32&scoped=true&"
import script from "./accessGuideMenu.vue?vue&type=script&lang=js&"
export * from "./accessGuideMenu.vue?vue&type=script&lang=js&"
import style0 from "./accessGuideMenu.vue?vue&type=style&index=0&id=4db6bf32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6bf32",
  null
  
)

export default component.exports